var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { staticClass: "px-2", attrs: { cols: "6" } },
            [
              _c("v-autocomplete", {
                ref: "userSelect",
                attrs: {
                  disabled: _vm.isCustomUser,
                  items: _vm.userList,
                  rules: [
                    function(v) {
                      return (
                        _vm.isCustomUser === true ||
                        v != null ||
                        _vm.$t("global.error.required")
                      )
                    }
                  ],
                  label: _vm.$t("travelService.orderUserSelect.person")
                },
                model: {
                  value: _vm.contextUser,
                  callback: function($$v) {
                    _vm.contextUser = $$v
                  },
                  expression: "contextUser"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "px-2", attrs: { cols: "6" } },
            [
              _c("v-checkbox", {
                attrs: {
                  label: _vm.$t("travelService.orderUserSelect.differentPerson")
                },
                model: {
                  value: _vm.isCustomUser,
                  callback: function($$v) {
                    _vm.isCustomUser = $$v
                  },
                  expression: "isCustomUser"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.isCustomUser
        ? _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { staticClass: "px-2" },
                [
                  _c("v-text-field", {
                    attrs: {
                      rules: [_vm.isRequired],
                      label: _vm.$t("user.name") + "*"
                    },
                    model: {
                      value: _vm.contextModel.name,
                      callback: function($$v) {
                        _vm.$set(_vm.contextModel, "name", $$v)
                      },
                      expression: "contextModel.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "px-2" },
                [
                  _c("v-text-field", {
                    attrs: {
                      rules: [_vm.isRequired],
                      label: _vm.$t("user.surname") + "*"
                    },
                    model: {
                      value: _vm.contextModel.surname,
                      callback: function($$v) {
                        _vm.$set(_vm.contextModel, "surname", $$v)
                      },
                      expression: "contextModel.surname"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.birthDateRequired
        ? _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { staticClass: "px-2", attrs: { cols: "6" } },
                [
                  _c("date-picker", {
                    attrs: {
                      rules: [_vm.isRequired],
                      label: _vm.$t("user.birthDate") + "*",
                      model: _vm.contextModel.birth_date
                    },
                    on: {
                      "update:model": function($event) {
                        return _vm.$set(_vm.contextModel, "birth_date", $event)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "py-5" },
                [
                  _vm.contextModel.company_user_id &&
                  _vm.$store.getters.hasPermission(
                    "saveUserDataFromTravelService"
                  )
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass: "my-0 py-0",
                                          attrs: {
                                            icon: "",
                                            disabled: !_vm.isUserDataDifferentFromUserProfile()
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.saveInUserProfile()
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [
                                          _vm._v("fa-cloud-upload-alt")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1103697245
                          )
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("global.saveInUserProfile")) +
                              " "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.contextModel.company_user_id
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass: "my-0 py-0",
                                          attrs: {
                                            icon: "",
                                            disabled: !_vm.isUserDataDifferentFromUserProfile()
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.writeSelectedUserData(
                                                _vm.contextUser
                                              )
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [
                                          _vm._v("fa-cloud-download-alt")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            312467565
                          )
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "components.travelUserInlineForm.loadFromUserProfile"
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }